import { render, staticRenderFns } from "./CenterAdmin.vue?vue&type=template&id=bea89f94&scoped=true"
import script from "./CenterAdmin.vue?vue&type=script&lang=js"
export * from "./CenterAdmin.vue?vue&type=script&lang=js"
import style0 from "./CenterAdmin.vue?vue&type=style&index=0&id=bea89f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea89f94",
  null
  
)

export default component.exports